import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'

import { API_BASE_URL, API_VERSION } from 'config/env.config'

export const GET_USER_PROFILE = 'EMPLOYEE/GET_USER_PROFILE'

const apiCall = enhancedMakeFetchAction(GET_USER_PROFILE, () => ({
  endpoint: generateEndpoint({
    host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/account/profile`
  }),

  method: 'GET'
}))

export default apiCall
